module.exports = __webpack_public_path__ + "img/tempuracaliforniafrontalshow.cdc8e561.jpg";